import { connect } from 'react-redux';
import View from './view';
import { ReduxState } from '../../types/redux_types';

const mapStateToProps = (state: ReduxState) => ({
  isAuthenticated: state.global.isAuthenticated,
  isPageLoading: state.global.pageRefreshLoading,
});

export default connect(mapStateToProps)(View);
